module.exports = __webpack_public_path__ + "img/aws.e3e4bd4e.svg";